<form [formGroup]="form">
  @if (form.contains('primaryContactId')) {
    <rt-form-field margin-bottom>
      <rt-label
        >{{ 'app.pricing.billing_contact_form.primary_contact_label' | translate }}
        <rt-icon-help
          [rtTooltip]="'app.pricing.billing_contact_form.primary_contact_tooltip' | translate"
          margin-left-small-x
      /></rt-label>

      <rt-user-select-container
        [control]="$any(form.controls.primaryContactId)"
        (valueChange)="form.get('primaryContactId')?.setValue($event)"
      />
    </rt-form-field>
  }

  @if (form.contains('fullName')) {
    <rt-form-field margin-bottom>
      <rt-label>{{ 'app.pricing.billing_contact_form.full_name_label' | translate }}</rt-label>
      <rt-input
        variant="rounded"
        formControlName="fullName"
        placeholder="{{ 'app.pricing.billing_contact_form.full_name_placeholder' | translate }}"
      />
    </rt-form-field>
  }

  @if (form.contains('email')) {
    <rt-form-field margin-bottom>
      <rt-label>{{ 'app.pricing.billing_contact_form.email_label' | translate }}</rt-label>
      <rt-input
        variant="rounded"
        formControlName="email"
        placeholder="{{ 'app.pricing.billing_contact_form.email_placeholder' | translate }}"
      />
    </rt-form-field>
  }

  @if (form.contains('phone')) {
    <rt-form-field margin-bottom>
      <rt-label>{{ 'app.pricing.billing_contact_form.phone_label' | translate }}</rt-label>
      <rt-phone-input
        [countryCode]="formValue.countryCode"
        [rtFormError]="phoneErrors"
        formControlName="phone"
        placeholder="{{ 'app.pricing.billing_contact_form.phone_placeholder' | translate }}"
      />
    </rt-form-field>
  }

  @if (form.contains('invoiceEmails')) {
    <rt-divider margin-tb />

    <rt-form-field>
      <rt-label>{{ 'app.pricing.billing_contact_form.invoice_emails_label' | translate }}</rt-label>
      <rt-tagger
        [placeholder]="
          form.get('invoiceEmails')!.value.length === 0 ? 'john@example.com, anna@example.com' : ''
        "
        [control]="$any(form.get('invoiceEmails'))"
        [tags]="form.get('invoiceEmails')!.value"
        [markInvalid]="true"
        [preserveWhiteSpaces]="true"
        [applyStyleOnFocus]="true"
        variant="email"
      />
    </rt-form-field>
  }
</form>
